import React from 'react';
import {useInView, IntersectionOptions} from 'react-intersection-observer';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {UseUserAgent} from "../composers/composer-plugins/use-user-agent";

const DefaultPlaceholder = (() => null);

export class IntersectionObserverProps extends BaseProps {
  Placeholder: React.Component;
  forceRender: Boolean;
  keepObserving: Boolean;
  targetContainerRef: Element;
  className: String;
  root: Element;
  margin: String;
  onIntersect: Function;
  onIntersectEnd: Function;
  threshold: Number;
  containerTag: String;
}

export const IntersectionObserver = UseUserAgent()((props: IntersectionObserverProps) => {
  const options: IntersectionOptions = {
    root: props.root || null,
    rootMargin: props.margin,
    threshold: props.threshold,
    triggerOnce: !props.keepObserving,
    initialInView: props.forceRender
  }

  const {userAgent: {isPrerender}} = props;

  const {ref, inView, entry} = useInView(options);

  if (entry?.isIntersecting) {
    props.onIntersect?.(entry.target);
  } else if (entry?.intersectionRatio === 0) {
    props.onIntersectEnd?.(entry.target);
  }

  const Placeholder = props.Placeholder || DefaultPlaceholder;
  const ContainerTag = props.containerTag || 'div';

  return (
    <ContainerTag ref={ref} className={props.className} style={props.style} key={props.key} onClick={props.onClick} id={props.id} onMouseEnter={() => props.onMouseEnter?.()}>
      {
        inView || isPrerender || props.forceRender ? props.children : <Placeholder/>
      }
    </ContainerTag>
  )
});
